import { SettingProps } from "../../setting/models/Setting";
import {
  WithSettings,
  WithSettingsConstructor,
} from "../../setting/models/WithSettings";
import { Domain } from "./Domain";
import { DomainSection, DomainSectionProps } from "./DomainSection";
import { PageCreationType } from "./enums/PageCreationType";

export interface DomainCreateConstructor
  extends Omit<Domain, "id" | "settings">,
    WithSettingsConstructor {
  page_creation_type: PageCreationType;
  sections: DomainSectionProps[];
}

export class DomainCreate extends WithSettings implements Omit<Domain, "id"> {
  public readonly name: string;
  public readonly domain_url: string;
  public readonly page_creation_type: PageCreationType;
  public readonly sections: DomainSection[];

  constructor(constructor: DomainCreateConstructor) {
    super(constructor);
    this.name = constructor.name;
    this.domain_url = constructor.domain_url;
    this.page_creation_type = constructor.page_creation_type;
    this.sections = constructor.sections.map(
      (section) => new DomainSection(section)
    );
  }

  toFormData(): FormData {
    const formData = new FormData();

    formData.append("name", this.name);
    formData.append("domain_url", this.domain_url);
    formData.append("page_creation_type", this.page_creation_type);

    this.sections.forEach((section, index) => {
      formData.append(`section[${index}][name]`, section.name);
      formData.append(
        `section[${index}][category_file]`,
        section.category_file
      );
      formData.append(`section[${index}][content_file]`, section.content_file);
    });

    this.settings.forEach((setting, index) => {
      formData.append(`settings[${index}][key]`, setting.key);
      formData.append(`settings[${index}][value]`, String(setting.value));
    });

    return formData;
  }
}
